<template>
  <div class="w-auto h-auto">
    <img :src="imgUrl" class="w-full h-full" alt="">
  </div>
</template>

<script>
export default {

        data()  {
      return {
        imgUrl: new URL('@/assets/FinalSubmit.png', import.meta.url).href
      }
    }

}
</script>

<style>

</style>
